var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.512,
    height: 17.512,
    viewBox: "0 0 17.512 17.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_person_24px",
    d: "M12.756,12.756A4.378,4.378,0,1,0,8.378,8.378,4.377,4.377,0,0,0,12.756,12.756Zm0,2.189C9.834,14.945,4,16.412,4,19.323v2.189H21.512V19.323C21.512,16.412,15.678,14.945,12.756,14.945Z",
    transform: "translate(-4 -4)",
    fill: "#005465"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.ee377cf7be585877e5674fabcc53211b.svg";
export { ForwardRef as ReactComponent };